import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

// import selectors
import { getCardById } from 'js/store/cards/Cards.selectors';
import { getSiteMetaData } from 'js/store/app/App.selectors';

// import components
import GenericMetadata from 'js/components/generic/Generic.metadata';
import ActivityCard from 'js/components/activity-card/ActivityCard';

const CardFullView = () => {
  const siteMetaData = useSelector((state) => getSiteMetaData(state, '/card/{id}'));

  const { cardId } = useParams();
  const card = useSelector((state) => getCardById(state, cardId));

  const {
    title = '',
    back: { description = '' },
  } = card || {};

  const metaTitle = siteMetaData?.title?.replace('{title}', title) || title;
  const metaDescription = siteMetaData?.description?.replace('{description}', description) || '';
  const metaKeywords = siteMetaData?.keywords?.replace('{title}', title) || '';

  return (
    <>
      <GenericMetadata title={metaTitle} description={metaDescription} keywords={metaKeywords} />
      <ActivityCard data={card} />
    </>
  );
};

export default CardFullView;
